import Seo from "@/components/Seo";
import { Eyebrow } from "@/components/Reveal";
import { CountryCard } from "@/components/CountryCard";
import { MarqueeRibbon } from "@/components/MarqueeRibbon";
import { countries } from "@/data/countries";

const regionSections = [
  {
    name: "Middle East",
    headline: "Desert light, Gulf modernity, and the Haramain",
    blurb: "The spiritual center of gravity. The easiest logistics, the strongest safety, and — honestly — the highest price tags. This is where jobs and scholarships open doors.",
  },
  {
    name: "Asia",
    headline: "Ottoman Istanbul to tropical Malaysia",
    blurb: "The best value on the map: visa-friendly entries, English that actually works, and halal as the default setting. Where a modest US income becomes a comfortable life.",
  },
  {
    name: "Africa",
    headline: "Where Islam first crossed the sea",
    blurb: "Egypt's unmatched scholarship, Morocco's twelve-century beauty, and the Swahili coast's gentle rhythm — maximum deen per dollar for families willing to learn the language.",
  },
];

export default function Countries() {
  return (
    <div data-testid="countries-page" className="pt-24 lg:pt-28 bg-cream min-h-screen grain relative">
      <Seo
        title="Country Profiles — Hijrah Mom"
        siteName="Hijrah Mom"
        description="In-depth hijrah profiles of 11 Muslim-majority destinations across the Middle East, Asia, and Africa: visas for US citizens, weather, cities, schools, healthcare, cost of living, and honest opinions."
      />
      <section className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-12 lg:py-16">
        <Eyebrow>Eleven countries, chapter & verse</Eyebrow>
        <h1 className="mt-4 font-serif font-bold text-ink text-4xl sm:text-5xl lg:text-6xl tracking-tight max-w-3xl leading-[1.05]">
          Read this before <span className="italic text-petal">you book anything.</span>
        </h1>
        <p className="mt-6 text-sage max-w-2xl leading-relaxed">
          Every profile covers what a relocating mother actually needs: US-citizen visas, year-round weather, the cities where the community lives, schools, healthcare, budgets — and my honest take at the end. Browse by region:
        </p>

        {regionSections.map((r) => (
          <div key={r.name} className="mt-16 first:mt-14" data-testid={`region-section-${r.name.toLowerCase().replace(/\s/g, "-")}`}>
            <div className="max-w-2xl mb-8 border-l-2 border-petal pl-6">
              <p className="font-mono text-xs tracking-[0.3em] uppercase text-petal">{r.name}</p>
              <h2 className="mt-2 font-serif font-semibold text-2xl lg:text-3xl text-ink">{r.headline}</h2>
              <p className="mt-2 text-sage leading-relaxed">{r.blurb}</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
              {countries.filter((c) => c.region === r.name).sort((x, y) => x.name.localeCompare(y.name)).map((c, i) => (
                <CountryCard key={c.slug} country={c} index={i} />
              ))}
            </div>
          </div>
        ))}

        <p className="mt-12 text-center font-serif italic text-xl text-sage-muted">
          Eleven lands and counting — new chapters are added as I research them, in shaa Allah.
        </p>
      </section>
      <MarqueeRibbon />
    </div>
  );
}
